export interface VideoItem {
  id: string;
  title: string;
  category: string;
  image: string;
  description: string;
  views: string;
  rating: number;
  year: string;
  region: string;
  tags: string[];
}

export const categories = [
  { id: 'guochan', name: '日韩国产在线', slug: 'guochan' },
  { id: 'jiqing', name: '日韩激情在线', slug: 'jiqing' },
  { id: 'jingpin', name: '日韩精品在线', slug: 'jingpin' },
  { id: 'jiujiu', name: '日韩久久在线', slug: 'jiujiu' },
  { id: 'gaoqing', name: '日韩高清在线', slug: 'gaoqing' },
];

export const videos: VideoItem[] = [
  {
    id: 'v1',
    title: '东京爱情故事 2024 重制版',
    category: 'guochan',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Japanese%20drama%20scene%20with%20couple%20walking%20in%20Tokyo%20streets%20at%20sunset%2C%20warm%20amber%20lighting%2C%20cinematic%20composition%2C%20soft%20bokeh%20background%2C%20emotional%20atmosphere&width=800&height=450&seq=video-card-01&orientation=landscape',
    description: '经典日剧《东京爱情故事》2024年4K重制版，重温永尾完治与赤名莉香的动人爱情故事。',
    views: '128.5万',
    rating: 9.2,
    year: '2024',
    region: '日本',
    tags: ['爱情', '经典', '日剧'],
  },
  {
    id: 'v2',
    title: '釜山行3：新纪元',
    category: 'jiqing',
    image: 'https://readdy.ai/api/search-image?query=Intense%20Korean%20action%20thriller%20scene%20with%20dramatic%20urban%20landscape%2C%20warm%20orange%20and%20dark%20tones%2C%20cinematic%20lighting%2C%20tense%20atmosphere%2C%20professional%20film%20aesthetic&width=800&height=450&seq=video-card-02&orientation=landscape',
    description: '韩国丧尸灾难大片续作，末日危机再度降临，人类最后的希望悬于一线。',
    views: '356.2万',
    rating: 8.7,
    year: '2025',
    region: '韩国',
    tags: ['动作', '灾难', '丧尸'],
  },
  {
    id: 'v3',
    title: '深夜食堂 第六季',
    category: 'jingpin',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20restaurant%20interior%20at%20night%20with%20warm%20lighting%2C%20wooden%20counter%2C%20steaming%20food%2C%20intimate%20atmosphere%2C%20cinematic%20photography%2C%20soft%20shadows&width=800&height=450&seq=video-card-03&orientation=landscape',
    description: '深夜食堂再度营业，每一道菜背后都是一个温暖人心的故事，治愈系日剧巅峰之作。',
    views: '89.3万',
    rating: 9.5,
    year: '2025',
    region: '日本',
    tags: ['美食', '治愈', '人生'],
  },
  {
    id: 'v4',
    title: 'Running Man 2025 新春特辑',
    category: 'jiujiu',
    image: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20energetic%20scene%20with%20colorful%20confetti%20and%20celebration%2C%20bright%20studio%20lighting%2C%20dynamic%20composition%2C%20playful%20atmosphere%2C%20professional%20broadcast%20quality&width=800&height=450&seq=video-card-04&orientation=landscape',
    description: '韩国最长寿综艺Running Man新春特别企划，爆笑游戏与新年祝福齐飞。',
    views: '215.7万',
    rating: 9.0,
    year: '2025',
    region: '韩国',
    tags: ['综艺', '搞笑', '游戏'],
  },
  {
    id: 'v5',
    title: '鬼灭之刃 无限城篇 剧场版',
    category: 'gaoqing',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20epic%20battle%20scene%20with%20dynamic%20samurai%20characters%2C%20vibrant%20fire%20effects%2C%20dramatic%20lighting%2C%20cinematic%20anime%20art%20style%2C%20intense%20action%20composition&width=800&height=450&seq=video-card-05&orientation=landscape',
    description: '年度最受期待动画电影，炭治郎与鬼杀队迎来最终决战，4K HDR画质震撼呈现。',
    views: '567.8万',
    rating: 9.8,
    year: '2025',
    region: '日本',
    tags: ['动漫', '热血', '剧场版'],
  },
  {
    id: 'v6',
    title: '半泽直树3',
    category: 'guochan',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20office%20drama%20scene%20with%20businessman%20in%20modern%20corporate%20setting%2C%20dramatic%20lighting%2C%20professional%20atmosphere%2C%20cinematic%20composition%2C%20warm%20interior%20tones&width=800&height=450&seq=video-card-06&orientation=landscape',
    description: '银行职场传奇续作，半泽直树再战金融界黑暗势力，「加倍奉还」再度上演。',
    views: '432.1万',
    rating: 9.3,
    year: '2025',
    region: '日本',
    tags: ['职场', '剧情', '金融'],
  },
  {
    id: 'v7',
    title: '与神同行3：轮回',
    category: 'jiqing',
    image: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20epic%20scene%20with%20mythological%20underworld%20setting%2C%20dramatic%20lighting%2C%20grand%20scale%2C%20cinematic%20composition%2C%20warm%20golden%20and%20dark%20tones&width=800&height=450&seq=video-card-07&orientation=landscape',
    description: '韩国奇幻巨制第三部，地狱使者再启轮回之旅，命运交织的终极审判。',
    views: '289.4万',
    rating: 8.9,
    year: '2025',
    region: '韩国',
    tags: ['奇幻', '剧情', '感人'],
  },
  {
    id: 'v8',
    title: '孤独的美食家 第十一季',
    category: 'jingpin',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20food%20documentary%20style%20scene%20with%20delicious%20ramen%20bowl%20in%20small%20traditional%20restaurant%2C%20warm%20lighting%2C%20appetizing%20steam%2C%20cozy%20atmosphere%2C%20cinematic%20food%20photography&width=800&height=450&seq=video-card-08&orientation=landscape',
    description: '井之头五郎的美食之旅继续，走遍日本大街小巷，探寻最地道的街头美味。',
    views: '156.8万',
    rating: 9.4,
    year: '2025',
    region: '日本',
    tags: ['美食', '纪录片', '旅行'],
  },
  {
    id: 'v9',
    title: '进击的巨人 最终季 完结篇',
    category: 'gaoqing',
    image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20apocalyptic%20scene%20with%20giant%20titans%20and%20wall%2C%20dramatic%20sky%2C%20cinematic%20animation%20quality%2C%20intense%20atmosphere%2C%20warm%20sunset%20tones&width=800&height=450&seq=video-card-09&orientation=landscape',
    description: '现象级动画完结篇，艾伦与调查兵团的最终命运揭晓，十年连载史诗落幕。',
    views: '892.3万',
    rating: 9.6,
    year: '2025',
    region: '日本',
    tags: ['动漫', '热血', '完结'],
  },
  {
    id: 'v10',
    title: '认识的哥哥 2025',
    category: 'jiujiu',
    image: 'https://readdy.ai/api/search-image?query=Korean%20entertainment%20talk%20show%20classroom%20set%20with%20colorful%20decor%2C%20bright%20studio%20lighting%2C%20funny%20atmosphere%2C%20celebrity%20guests%2C%20professional%20broadcast%20quality&width=800&height=450&seq=video-card-10&orientation=landscape',
    description: '韩国人气脱口秀新一季，超人气偶像齐聚校园，爆笑问答与才艺展示。',
    views: '178.3万',
    rating: 8.8,
    year: '2025',
    region: '韩国',
    tags: ['综艺', '脱口秀', '偶像'],
  },
  {
    id: 'v11',
    title: '咒术回战 涩谷事变篇',
    category: 'gaoqing',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20urban%20battle%20scene%20with%20sorcerers%20fighting%20in%20modern%20city%2C%20dynamic%20action%2C%20vibrant%20energy%20effects%2C%20cinematic%20anime%20style%2C%20dramatic%20lighting&width=800&height=450&seq=video-card-11&orientation=landscape',
    description: '年度话题动画续作，五条悟封印事件正式开启，咒术界史上最大危机。',
    views: '723.6万',
    rating: 9.7,
    year: '2025',
    region: '日本',
    tags: ['动漫', '战斗', '超人气'],
  },
  {
    id: 'v12',
    title: '机智的医生生活 第三季',
    category: 'jingpin',
    image: 'https://readdy.ai/api/search-image?query=Korean%20medical%20drama%20warm%20hospital%20scene%20with%20doctors%20smiling%2C%20soft%20lighting%2C%20professional%20medical%20setting%2C%20heartwarming%20atmosphere%2C%20cinematic%20composition&width=800&height=450&seq=video-card-12&orientation=landscape',
    description: '五位医生的友情与日常再度展开，温暖治愈的医院故事，每一集都让人泪目。',
    views: '198.5万',
    rating: 9.5,
    year: '2025',
    region: '韩国',
    tags: ['医疗', '友情', '治愈'],
  },
];